export default {
  data () {
    return {
      dataMixinUserFields: [
        {
          label: '',
          key: 'isBlocked',
          tdClass: 'call-tabel-icon',
          thClass: 'call-tabel-icon'
        },
        {
          label: 'ID',
          key: 'id',
          sortable: false,
          tdClass: 'call-td call-td--grey',
          thClass: 'call-th'
        },
        {
          label: 'Name',
          key: 'name',
          sortable: false,
          tdClass: 'call-td call-td--bold call-td--no-wrap',
          thClass: 'call-th'
        },
        {
          label: 'Email',
          key: 'email',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Team',
          key: 'teams',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Call Mode',
          key: 'call_mode',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Created at',
          key: 'created_at',
          sortable: true,
          tdClass: 'call-td',
          thClass: 'call-th',
          thStyle: { 'min-width': '170px' }
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'call-tabel-action',
          thClass: 'call-tabel-action'
        }
      ]
    };
  },
  methods: {
    onHover (item) {
      item.actions = true;
    },
    onUnHover (item) {
      item.actions = false;
    }
  }
};
